


















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CheckIcon extends Vue {
  @Prop({ type: String, default: 'white' }) private color!: string;
}
